import checkout from "./form";
import { dateFormatWithDash } from "../../../../../components/helper";

const {
  formField: { title, type, recommendation, item, itinerary, trendingStartD, trendingEndD },
} = checkout;
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);

const initialValues = {
  [title.name]: "",
  [type.name]: "recommendation",
  [recommendation.name]: "",
  [item.name]: "",
  [itinerary.name]: "",
  [trendingStartD.name]: dateFormatWithDash(today),
  [trendingEndD.name]: dateFormatWithDash(tomorrow),
};

export default initialValues;
